AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Subject");

AoPS.Alcumus.Models.Subject = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMTrialColl = AoPS.Alcumus.Models.TrialCollection;
	var AlcMProbStats = AoPS.Alcumus.Models.ProblemStats;

	return AlcMBase.BaseModel.extend({
		model_type: "subject",
		id_attribute: "subject_id",
		defaults: {
			name: "",
			alias: "",
			xp: 0,
			level: 0,
			xp_in_level: 0,
			xp_to_next: 0,
			xp_percent: 0,
			score: 0,
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			problem_stats: ProblemStats model with problem totals
			topics: collection of Topic models
			trials: collection of Trial models that are loaded for this subject
		*/

		initialize: function () {
			this.set("problem_stats", new AlcMProbStats());

			this.set("topics", new AlcMBase.BaseCollection());
			// Ensure we always have the same model as in the user's collection.
			this.get("topics").setCreateFunction(
				_.bind(function (id) {
					var result = this.get("user").get("topics").getOrCreate(id);
					result.set("subject", this);
					return result;
				}, this)
			);
			this.get("topics").comparator = "order";

			this.set("trials", new AlcMTrialColl());
			// Ensure we always have the same model as in the user's collection.
			this.get("trials").setCreateFunction(
				_.bind(function (id) {
					return this.get("user").get("trials").getOrCreate(id);
				}, this)
			);

			this.get("trials").setLoadParams({
				user_id: this.get("user").id,
				subject_id: this.id,
			});
			this.get("trials").watchUser(this.get("user"));
		},

		requestLoad: function (callback, context) {
			this.get("user").requestLoad(callback, context);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);

			this.get("problem_stats").unpack(data);

			// AJAX provides topic data separately and only hands us a list of IDs.
			var topic_list;
			if (data.topic_id_list) {
				topic_list = _.map(
					data.topic_id_list,
					function (topic_id) {
						var topic = this.get("topics").getOrCreate(topic_id, {
							delay_add: true,
						});
						topic.set("subject", this);
						return topic;
					},
					this
				);
				this.get("topics").add(topic_list);
			}
		},
	});
})();
